import { TrackColorService } from '@/services/trackColorService'
import type { Track } from '@/types/tour'

type TourAccentTrackSource = Pick<Track, 'color'>
type TourAccentTourSource = {
  tracks?: ReadonlyArray<TourAccentTrackSource> | null
}

export function resolveTourAccentColor(
  source: TourAccentTourSource | ReadonlyArray<TourAccentTrackSource> | null | undefined,
): string {
  const tracks = Array.isArray(source)
    ? source
    : source && 'tracks' in source
      ? (source.tracks ?? undefined)
      : undefined
  const firstTrackColor = tracks?.[0]?.color

  return TrackColorService.ensureValidColor(firstTrackColor)
}
